import styles from "./ContentBlock.module.css";

export default function Quote({ text }) {
  return (
    <div className={styles.quote} dangerouslySetInnerHTML={{ __html: text }} />
  );
}
